<template>
    <div ref="typeform" class="typeform-widget"/>
</template>
<script>
import { makeWidget } from '@typeform/embed';
import { CastingConsumer } from '@skeepers/platform-framework/mixins';

export default {
    name: 'TypeformWidget',
    mixins: [CastingConsumer],
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        /**
         * Typeform URL for this client with hidden fields
         */
        typeformURL () {
            return `https://teester.typeform.com/to/${this.id}?application=${this.application.id}`;
        },
    },
    mounted () {
        // https://developer.typeform.com/embed/modes/#widget-mode
        makeWidget(this.$refs.typeform, this.typeformURL, {
            onSubmit: this.onSubmit,
        });
    },
    destroyed () {
        document.body.classList.remove('__typeform-embed-mobile-modal-open');
    },
    methods: {
        onSubmit () {
            this.$emit('submit');
        },
    },
};
</script>
<style lang="scss">
// The typeform widget uses height: 100%, which is incompatible
// with flexbox. Thus we must work around it
.typeform-widget {
    flex-grow: 1;
    display: flex;

    > div {
        height: unset;
        flex: 1;
    }
}
</style>
